import { useQuery } from "@tanstack/react-query";
import { useGrpcApiStore } from "../grpc/grpcApiStore";
import { GetUIFeatures } from "gc-web-proto/galaxycompletepb/apipb/api_pb";
import { AppGlobalQueryKeys } from "../../common/QueryKeys";
import { FeatureFlag } from "./AppGlobalState";
import { useIsAuthenticated } from "../auth/auth_hooks";

const FEATURE_FLAG_REFETCH_MS = 5 * 60 * 1000;

export const useGetUIFeatures = () => {
    const apis = useGrpcApiStore();
    const isAuthenticated = useIsAuthenticated();
    return useQuery({
        queryKey: [AppGlobalQueryKeys.getUIFeatures],
        queryFn: async () => {
            const req = new GetUIFeatures.Request().setFeaturesRequestedList(Object.values(FeatureFlag));
            const res = await apis.generalService.getUIFeatures(req, null);
            return res.toObject();
        },
        enabled: isAuthenticated,
        refetchInterval: FEATURE_FLAG_REFETCH_MS,
    });
};

export const useIsFeatureEnabled = (feat: FeatureFlag): boolean => {
    const { data } = useGetUIFeatures();
    return data?.enabledFeaturesList?.includes(feat) ?? false;
};
